import type { MediaTrack } from '@viva/player';
import { t } from '../../i18n';

interface TrackMenuProps {
  kind: 'audio' | 'text' | 'quality';
  tracks: MediaTrack[];
  onSelect: (id: string | null) => void;
}

/** Audio, subtitle or quality choices; subtitles also offer "Off". */
export function TrackMenu({ kind, tracks, onSelect }: TrackMenuProps) {
  const anyActive = tracks.some((track) => track.active);
  return (
    <ul className="player__menu" role="menu">
      {kind === 'text' ? (
        <li>
          <button type="button" role="menuitemradio" aria-checked={!anyActive} onClick={() => onSelect(null)}>
            {t('player.off')}
          </button>
        </li>
      ) : null}
      {tracks.map((track) => (
        <li key={track.id}>
          <button type="button" role="menuitemradio" aria-checked={track.active} onClick={() => onSelect(track.id)}>
            {track.label}
          </button>
        </li>
      ))}
    </ul>
  );
}
